
import { MainframeAssessmentOutput } from '@amzn/awscat-portfolio-assessment-types';
import { NonCancelableCustomEvent, Tabs, TabsProps } from '@amzn/awsui-components-react';
import React, { useState } from 'react';

import { constants } from '../../../common/Localization';
import MainframeCashflowTab from './CashflowTab';
import MainframeDetailsTab from './DetailsTab';
import MainframeSummaryTab from './SummaryTab';

type Props = {mainframe: MainframeAssessmentOutput};

function BusinessCasePage({ mainframe }: Props) {
    const { currency, migrationCosts, onPremCosts, awsCosts, cashflow, resources } = mainframe;
    
    const [selectedTab, setSelectedTab] = useState('summaryTab');

    function selectedTabChanged(event: NonCancelableCustomEvent<TabsProps.ChangeDetail>): void {
        setSelectedTab(event.detail.activeTabId);
    }

    const summaryTabContent = (
        <MainframeSummaryTab
            currency={currency}
            migrationCosts={migrationCosts}
            onPremCosts={onPremCosts}
            awsCosts={awsCosts}
        />
    );

    const cashflowTabContent = (
        <MainframeCashflowTab
            currency={currency}
            cashflow={cashflow}
        />
    );

    const detailsTabContent = (
        <MainframeDetailsTab
            currency={currency}
            resources={resources}
        />
    );

    const tabDefinitions = [
        {
            content: summaryTabContent,
            id: 'summaryTab',
            label: constants.MAINFRAME_TAB_LABEL_SUMMARY,
        },
        {
            content: cashflowTabContent,
            id: 'cashflowTab',
            label: constants.MAINFRAME_TAB_LABEL_CASH_FLOW,
        },
        {
            content: detailsTabContent,
            id: 'detailsTab',
            label: constants.MAINFRAME_TAB_LABEL_AWS_DETAILS,
        },
    ];

    return (
        <Tabs
            tabs={tabDefinitions}
            activeTabId={selectedTab}
            onChange={selectedTabChanged}
        />
    );

}

export default BusinessCasePage;
